<template>
  <div class="page-wrap">
    <div>
      <el-breadcrumb separator="/" class="breadcrumb">
        <el-breadcrumb-item>渠道档案</el-breadcrumb-item>
        <el-breadcrumb-item class="linkpath" @click.native="isShowAddmodal(false)">经销商档案</el-breadcrumb-item>
        <el-breadcrumb-item v-if="linkpath != '' && linkpath != '编辑' && linkpath != '新增'">{{linkpath}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="page" v-if="!isClicked || isClicked == 'add' || isClicked == 'edit'">
       <!-- 顶部查询框 -->
      <section class="seaerch-wrapper">
        <el-form :model="searchform" class="search-form"  style="margin-left: -20px;">
          <el-form-item label="经销商名称" :label-width="formLabelWidth">
            <el-input v-model="searchform.dealername" placeholder="请输入" autocomplete="on" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="经销商联系人" :label-width="formLabelWidth">
            <el-input v-model="searchform.takepeople" placeholder="请输入" autocomplete="on" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="经销商联系方式" :label-width="formLabelWidth">
            <el-input v-model="searchform.contact" placeholder="请输入" autocomplete="on" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="经销商层级" :label-width="formLabelWidth">
            <el-select v-model="searchform.level" placeholder="请选择" size="small" clearable>
                <el-option
                v-for="item in levelData"
                :key="item.level"
                :value="item.level"
                :label="item.alias ? item.alias : item.moudle"

                ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item></el-form-item>
          <el-form-item>
            <el-button size="small" class="search-btn" @click="QueryTable()">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
      <!-- min-height:calc(100% - 206px) -->
      <section class="content-warpper" style="min-height: 636px;">
        <!-- 操作按钮 -->
        <el-row v-if="userData.logintype != 'HCMSUB' && userData.bmcid != '2881'">
          <el-button size="small" icon="el-icon-plus" type="primary" @click="newAddStore">新增</el-button>
          <el-button size="small" type="default" @click="mulDeleteClick">批量删除</el-button>
          <el-button size="small" type="default" @click="mulImportClick">批量导入</el-button>
          <el-button size="small" type="default" @click="importTempdownClick" :loading="Tempdown">导入模板下载</el-button>
          <el-button size="small" type="default" @click="downLoadDataClick" :loading="LoadData">下载数据</el-button>
          <el-button size="small" class="changeBtn" type="default" @click="changeHistoryClick(null)">变更历史</el-button>
        </el-row>
        <!-- 数据表格 -->
        <el-row>
          <dataTable
              ref="dataTable"
              :isNotice="true"
              :tableData="tableData"
              :colums="gridColumns"
              type="selection" showIndex="index"
              :pageConfig="pageOption"
              @searchTable="pageChange"
              @selectionChange="selectionChange"
              @rowClick="linkDetail"
              @checkAll="selectAll"
          >
            <!-- 操作列 -->
            <el-table-column v-if="gridColumns.length>0 && userData.logintype != 'HCMSUB' && userData.bmcid != '2881'" slot="operation" label="操作" width="150px" class-name="operate" fixed="right">
              <template slot="header">
                <span>操作<i class="el-icon-setting setting" @click="setTableTitle"></i></span>
              </template>
              <template slot-scope="scope">
                <span class="op-btn edit"  @click.stop="handleEdit(scope.$index, scope.row)"><i class="el-icon-edit-outline"></i> 编辑</span><span class="verline">|</span>
                <el-dropdown >
                  <span class="el-dropdown-link op-btn" @click.stop="">
                    <i class="el-icon-more"></i>更多
                  </span>
                  <el-dropdown-menu slot="dropdown" trigger="click">
                    <el-dropdown-item @click.native="changeHistoryClick(scope.row)">变更历史</el-dropdown-item>
                    <el-dropdown-item @click.native="handleDelete(scope.$index, scope.row)">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </dataTable>
        </el-row>
        <!-- 设置表头弹框 -->
        <setTableTitle :modalInfo="setModalInfo"  @reqTableData="reqTableData" ref="setModal"/>
        <!-- 批量导入弹框 -->
        <importModal :modalInfo="importmodelInfo" :columsDataErr="gridColumns"  @reqTableData="reqTableData" />
        <!-- 详情弹框 -->
        <shopRightDetail :modalInfo="detailModalInfo" :editModalInfo="addmodelInfo" @linkDetailDetail="linkDetailDetail" ref="detailModal" @editClick="editClick"  @reqDetail="linkDetail" @reqTableData="reqTableData"/>
      </section>
    </div>
    <!-- 新增/编辑授权店铺 -->
    <newAddModel ref="newAddModelShow" :modalInfo="addmodelInfo" @reqTableData="reqTableData" @getIsshow="isShowAddmodal" v-show="isClicked == 'add' || isClicked == 'edit'"/>
    <!-- 变更历史 -->
    <changehistory :modalInfo="historymodelInfo" ref="changeHistory" v-if="isClicked == 'changehistory'"/>
    <!-- 删除 -->
    <delElDialog ref="delDialog" @deldata="deldata"/>
  </div>
</template>

<script>
import dataTable from "components/dataTable";
import delElDialog from "components/delElDialog";
import setTableTitle from "components/setTableTitle";  //设置表头
import newAddModel from "./addNewModel"; //新增/编辑
import changehistory from "../commonChangeHistory/changeHistory"; //变更历史
import importModal from "../commonImportModal/importModel";  //批量导入
import shopRightDetail from "./shopRightDetail"; //详情弹框
import { renderShopName ,renderProductInfo,renderDialog} from "@/libs/renderCommon";
import {fetchGet, fetchPost} from "@/libs/reqCommon";
import { mapState, mapGetters ,mapActions} from 'vuex';

export default {
  components: {dataTable,importModal,shopRightDetail,setTableTitle ,newAddModel ,changehistory ,delElDialog},
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      Tempdown: false,
      LoadData: false,
      tableloading: false,
      linkpath:'',
      searchform:{level:'',dealername:'',takepeople:'',contact:''},
      formLabelWidth: "110px",
      isClicked:'',isActive:'add',

      query:{
        pageNo:1,pageSize:10,level:''
      },
      pageOption:{isPage:true,total:0},
      gridColumns:[],
      tableData: [],
      addmodelInfo:{}, // 新增/编辑弹框属性 1新增 2编辑 3删除

      setModalInfo:{},//设置表头弹框属性
      addField:[],//新增字段
      basicField:[],//基础字段
      selected:[],//已选择的项

      historymodelInfo:{},//变更历史
      importmodelInfo:{},//批量导入弹框属性
      detailModalInfo:{},//详情弹框
      levelData: [],
    };
  },
  computed: {
    ...mapState({
        levelList: state => state.commonList.levelList,
        dealernameList: state => state.commonList.dealernameList
    }),
  },
  filters: {
    levelFilter: function (value) {
        if(value == 1) return '一级经销商'
        else if(value == 2) return '二级经销商'
        else if(value == 3) return '三级经销商'
        else if(value == 4) return '四级经销商'
        else if(value == 5) return '五级经销商'
    }
  },
  watch:{
    $route(newVal,oldVal){
      if(newVal.name == oldVal.name){
        this.initTableColum();
        this.getTabledata(this.query);
        this.linkpath = '';this.isClicked = '';
      }
    }
  },
  created() {
    this.initTableColum();
    this.getTabledata(this.query);
    this.initDealerLevelAlias()
  },
  mounted(){},
  methods: {
    initDealerLevelAlias() {
      fetch({
        url: "hcm/cus/initDealerLevelAlias",
        method: "post",
      }).then(res => {
        if(res.status == "10000"){
          this.getDealerLevelAlias()
        }
      });
    },
    getDealerLevelAlias() {
      fetch({
        url: "hcm/cus/getDealerLevelAlias",
        method: "post",
      }).then(res => {
        if(res.status == "10000"){
          this.levelData = []
          this.levelData = res.data
        }
      });
    },
    deldata() {
      this.initTableColum();
      this.getTabledata(this.query);
    },
    linkDetailDetail(value) {
      this.linkDetail(value)
    },
    reqTableData(){
      this.initTableColum();
      this.getTabledata(this.query);
    },
    isShowAddmodal(val){
      if(!val)
      this.$route.query.isClicked = '';
      this.linkpath = '';this.isClicked = '';
      this.$nextTick(()=>{
        this.$refs.dataTable.pageOption.pageSize = this.query.pageSize;
        this.$refs.dataTable.pageOption.pageNo = this.query.pageNo;
      })
      this.getTabledata(this.query)
    },
    // 点击搜索查询
    searchClick(){
      if(!this.Keywordname){
        this.$message({
          message: '请先输入关键字',
          type: 'warning'
        })
      }else {
        this.query.keywordname  = this.Keywordname;
        this.getTabledata(this.query);
      }
    },
    // 查询
    QueryTable(){
      let query = {
          pageNo:1,
          pageSize:this.query.pageSize,
          ...this.searchform,
          // level:this.searchform.level?this.searchform.level:0,
      }
      // console.log(this.searchform.level === '')
      // console.log(this.searchform.level === null)
      // console.log(!this.searchform.level)
      // if (this.searchform.level === '') {
      //   query.level = 0
      // } else {
      //   query.level = this.searchform.level
      // }

      this.getTabledata(query);
    },
    // 点击分页查询
    pageChange(pageOption){
      this.query.pageNo = pageOption.pageNo;
      this.query.pageSize = pageOption.pageSize;
      this.query = {
        ...this.query,
        ...this.searchform
      }
      this.getTabledata(this.query);
    },
    // 表格数据
    getTabledata(query){
        this.tableloading = true
       fetchGet("/hcm/dealer/getlist",{...query,...this.searchform}).then(res => {
          if(res.status == 10000){
            this.tableloading = false
            let _this = this;
            for(let i =0;i<res.data.content.length;i++){
              if(res.data.content[i].hlevelid||res.data.content[i].hlevelid==0){
                res.data.content[i].hlevelid = res.data.content[i].hlevelname
              }
              if(res.data.content[i].brmuserid||res.data.content[i].brmuserid==0){
                res.data.content[i].brmuserid = res.data.content[i].realname
              }
              if(res.data.content[i].level){
                res.data.content[i].level = res.data.content[i].level
              }
            }
            this.tableData = res.data.content;
            this.$set(_this.pageOption,"total",res.data.totalElements);
          }
       })
    },
    // 字段为address的时候拼接：province + city + strict + address
    renderAddress(gridColumns){
      if (gridColumns.prop == 'address') {
        gridColumns.width = 400;
        this.$set(gridColumns, "render", (h, params) => {
          let province = params.row.province?params.row.province:'';
          let city = params.row.city?params.row.city:'';
          let strict = params.row.strict?params.row.strict:'';
          let address = params.row.address?params.row.address:'';
          return h('span',{attrs:{title:province+city+strict+address}},province+city+strict+address);
        });
      }
    },
    // 初始化表头
    forColum(titles){
      titles.sort(this.compare("sort"))
      for (var i=0;i<titles.length;i++) {
        let field = {
          id:titles[i].id,
          label:titles[i].fieldname,
          prop:titles[i].fieldvalue?titles[i].fieldvalue:'',
          isChecked:titles[i].isChecked?true:false,
          fieldRequired:titles[i].fieldRequired,
          fieldClassify:titles[i].fieldClassify,
          width:
          titles[i].fieldvalue == 'address'?400:320
        }
        if(titles[i].isChecked)
          this.gridColumns.push(field)
        if(titles[i].fieldClassify == "basic"){
          if(titles[i].fieldvalue == "address"){  //如果存在address的地址字段，就手动添加一个下拉选择的地址字段，用来渲染表单的下拉地址控件
            let addressField = {
              label:"地址",
              prop:"selectAddress",
              isChecked:titles[i].isChecked?1:0,
              fieldRequired:titles[i].fieldRequired == '1'?'1':0,
              fieldClassify:'basic',
            }
            this.basicField.push(addressField)
          }
          this.basicField.push(field)
        }
        if(titles[i].fieldClassify == "add")
          this.addField.push(field)
      }
      this.setModalInfo.selfFields = this.addField;
      for (let i = 0; i < this.gridColumns.length; i++) {
        // 渲染地址字段
        this.renderAddress(this.gridColumns[i]);
        // 经销商名称(点击可查看详情)
        renderShopName(this.gridColumns[i],'dealername',null,this);
      }
      if(this.$route.query.isClicked == 'add'){
        this.newAddStore()
      }
    },
    initTableColum(){
      let query = { module:"DEALER"}
      fetchGet("/hcm/hcmCustomModel/getBybmcidAndModule",query).then(res =>{
        this.gridColumns = [];this.basicField=[];this.addField=[];
        if(res.status == "10000"){
          this.forColum(res.data.add.data.concat(res.data.basic.data))
        }
      });
    },
    // 表头排序
    compare (prop) {
      return function (obj1, obj2) {
        var val1 = obj1[prop];
        var val2 = obj2[prop];if (val1 < val2) {
            return -1;
        } else if (val1 > val2) {
            return 1;
        } else {
            return 0;
        }
      }
    },
    // 店铺详情（右侧弹框）
    linkDetail(row){
      let query = {
        dealerid:row.id
      }
      this.$refs.detailModal.loading = true;
      fetchGet("/hcm/dealer/findById",query).then(res =>{
        if(res.status == "10000"&&res.data){
          this.detailModalInfo = {
            isShow:true,
			detail:res.data,
			row:row
		  }
		  this.detailModalInfo.detail.binding = row.binding;
          this.$refs.detailModal.activeName = '1';
          this.detailModalInfo.gridColumns = this.gridColumns;
        }else{
          this.$message.error(res.message?res.message:"详情数据为空");
        }
        this.$refs.detailModal.loading = false;
      });
    },
    // 删除请求
    reqDelete(query,url){
       fetchPost(url,query).then(res =>{
        if(res.status == "10000"){
          this.$message({
            message: '操作成功！',
            type: res.message
          })
          this.getTabledata(this.query)
        }else{
          this.$message.error(res.message);
        }
      });
    },
    selectAll(isAll){
      if(isAll) this.selected.length = this.pageOption.total;
    },
    selectionChange(data){
      let ids = [];
      for(var i=0;i<data.length;i++){
        ids.push(data[i].id);
      }
      this.$set(this,'selected',ids)
    },
    // 批量删除
    mulDeleteClick(){
      if(this.selected.length == 0){
        this.$message.error('请先选择列表项！');
      }else{
        this.isActive = 'muldelete'
        // 删除全部
        if(this.selected.length == this.pageOption.total){
          let query = {...this.searchform,ids:"checkAll"}
          let url = "/hcm/dealer/delete"
          let func = this.reqDelete
          let info = {
            title:'你确认要删除全部的经销商档案吗?',
            infoccc:'删除后',infored:'经销商档案信息将会被全部彻底删除'
          }
          // renderDialog(info,url,query,func,this)
          this.$refs.delDialog.dialogData(info,url,query);
        }else{
          let query = {ids:String(this.selected),level:this.searchform.level}
          let url = "/hcm/dealer/delete"
          let func = this.reqDelete
          let info = {
            title:`你确认要删除${this.selected.length}条经销商档案信息吗？`,
            infoccc:'删除后',infored:`这${this.selected.length}条经销商档案信息将会被彻底删除`
          }
          // renderDialog(info,url,query,func,this)
          this.$refs.delDialog.dialogData(info,url,query);
        }
      }
    },
    // 删除当前行
    handleDelete(index,item){
      let query = {ids:item.id,level:this.searchform.level}
      let url = "/hcm/dealer/delete"
      let func = this.reqDelete
      let info = {
        title:`你确认要删除该经销商档案吗?`,
        infoccc:'删除后',infored:`该经销商档案信息将会彻底删除`
      }
      // renderDialog(info,url,query,func,this)
      this.$refs.delDialog.dialogData(info,url,query);
    },
    // 批量导入
    mulImportClick(){
      this.isActive = 'mulimport'
      this.importmodelInfo = {
        isShow:true,
        url:'/hcm/dealer/readExcelFile'}
    },
    // 下载数据
    downLoadDataClick(){
      this.LoadData = true
      let params = {
        istemplet: '0',
        level: this.searchform.level,
        dealername: this.searchform.dealername,
        takepeople: this.searchform.takepeople,
        contact: this.searchform.contact,
      }
      fetch({
          url: "/hcm/dealer/exportExcel",
          method: "get",
          params:params,
          noFormat: true,
          responseType: "blob"
      })
      .then((res)=>{
        //下载
        let url = window.URL.createObjectURL(new Blob([res]))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', '经销商档案数据.xlsx')
        document.body.appendChild(link)
        link.click()
        this.LoadData = false
      })
    },
    // 导入模板下载
    importTempdownClick(){
      this.Tempdown = true
      let params = {
        istemplet: "1",
        level: "",
      }
      fetch({
          url: "/hcm/dealer/exportExcel",
          method: "get",
          params:params,
          noFormat: true,
          responseType: "blob"
      })
      .then((res)=>{
        //下载
        let url = window.URL.createObjectURL(new Blob([res]))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', '经销商档案导入模板.xlsx')
        document.body.appendChild(link)
        link.click()
        this.Tempdown = false
      })
    },
    // 变更历史
    changeHistoryClick(row){
      let id = null;
      this.historymodelInfo.modulename = "DEALER";
      if(row){
        id = row.id;
        this.historymodelInfo.modulename = "DEALER";
      }
      this.isClicked = 'changehistory';
      this.linkpath = '变更历史';
      let _this = this;
      this.$nextTick(()=>{
        _this.$refs.changeHistory.reqChangeHistory(id);
      })
	},
	editClick(payload){
		this.handleEdit(payload.index,payload.row)
	},
    // 编辑事件
    handleEdit(index,row){
      let query = {
        dealerid:row.id
      }
      fetchGet("/hcm/dealer/findById",query).then(res =>{
        if(res.status == "10000" && res.data){
          this.isClicked = index || index === 0 ? "edit" : "";
          this.linkpath = index | index === 0 ? "编辑" : "";
          let dealernameList = this.dealernameList;
          let hlevelid = Number(res.data.hlevelid)==0?null:Number(res.data.hlevelid)
          this.addmodelInfo = {
          flag:"edit",
          props:this.basicField.concat(this.addField),
          basicform:{...res.data,dealerid:res.data.id,selectAddress:res.data.address,hlevelid:hlevelid,level:Number(res.data.levelcode)},
          addform:res.data,
    			addField:this.addField,
    			row:row,
    			ispanelEdit:index || index === 0 ?  false : true,
          }
          if (index != null) {
            this.$refs.newAddModelShow.ntm(this.addmodelInfo)
          }

        }else{
          this.$message.info("接口数据为空，编辑回显数据是掉的接口！");
        }
      });
    },
    // 获取form属性
    getFormProp(formProp){
      let props = [];
      let obj = {};
      for(let item of formProp){
        var propObj = {};
        propObj[item.prop] = "";
        props.push(propObj)
      }
      for(var i = 0;i<props.length;i++){
        Object.assign(obj,props[i],props[i+1])
      };
      return obj;
    },
    // 新增店铺档案
    newAddStore(){
      let basicform = this.getFormProp(this.basicField); //基本字段
      let addform = this.getFormProp(this.addField);  //新增字段
      this.isClicked = "add";
      this.linkpath = "新增";
      this.addmodelInfo = {
        flag:"add",
        props:this.basicField.concat(this.addField),
        basicform:basicform,
        addform:addform
      }
      this.$refs.newAddModelShow.ntm(this.addmodelInfo)
    },
    // 设置表头
    setTableTitle(){
      this.setModalInfo = {isShow:true}
      this.$refs.setModal.getFildData('DEALER')
    },

  },
};
</script>

<style lang="scss">
$highColor:#108cee;
.linkpath{
  &:hover{
    cursor: pointer;
    .el-breadcrumb__inner{
      color:$highColor!important;
    }
  }
}
.changeBtn{
  float: right;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>
